import React from 'react';
import './FileProgressOverlay.css';

interface FileProgressOverlayProps {
  progress: number; // 0-100
  isComplete: boolean;
  fileName: string;
}

const FileProgressOverlay: React.FC<FileProgressOverlayProps> = ({ 
  progress, 
  isComplete, 
  fileName 
}) => {
  const normalizedProgress = Math.max(0, Math.min(100, progress));
  const circumference = 2 * Math.PI * 20; // radius = 20
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (normalizedProgress / 100) * circumference;

  return (
    <div className="file-progress-overlay">
      <div className="progress-indicator">
        {isComplete ? (
          <div className="checkmark-container">
            <svg 
              className="checkmark" 
              viewBox="0 0 24 24" 
              width="32" 
              height="32"
            >
              <path 
                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                fill="white"
              />
            </svg>
          </div>
        ) : (
          <div className="pie-chart-container">
            <svg 
              className="pie-chart" 
              viewBox="0 0 48 48" 
              width="48" 
              height="48"
            >
              {/* Background circle */}
              <circle
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke="rgba(255, 255, 255, 0.3)"
                strokeWidth="4"
              />
              {/* Progress circle */}
              <circle
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray={strokeDasharray}
                strokeDashoffset={strokeDashoffset}
                transform="rotate(-90 24 24)"
                className="progress-circle"
              />
              {/* Progress text */}
              <text
                x="24"
                y="24"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="white"
                fontSize="10"
                fontWeight="bold"
              >
                {normalizedProgress}%
              </text>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileProgressOverlay; 